<template>
  <div
    class="content-wrapper"
    :class="{
      'horizontal-spacing': !withoutHorizontalSpacing,
      'h-full': fillHeight,
      'no-top-padding': noTopPadding,
      'no-bottom-padding': noBottomPadding,
      'no-left-margin': withoutLeftMargin,
    }"
  >
    <brand-search-bar
      v-if="query"
      :query="query"
      :hide-search="hideSearch"
      :hide-pagination="hidePagination"
      @select-limit="$emit('select-limit', $event)"
    />
    <slot></slot>
  </div>
</template>

<script>
import BrandSearchBar from '@/layouts/BrandLayout/Components/BrandSearchBar.vue';
export default {
  components: { BrandSearchBar },
  props: {
    query: Object,
    withoutHorizontalSpacing: Boolean,
    withoutLeftMargin: Boolean,
    fillHeight: Boolean,
    hideSearch: Boolean,
    hidePagination: Boolean,
    noTopPadding: Boolean,
    noBottomPadding: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  @apply pt-16 pb-8 flex-grow duration-500 ease-in overflow-auto relative;

  @screen md {
    @apply ml-sidebar;
  }
  @screen xxl {
    @apply ml-sidebar;
  }

  &.horizontal-spacing {
    @apply px-4;

    @screen md {
      @apply px-6;
    }
  }

  &.no-top-padding {
    @apply pt-0;
  }

  &.no-bottom-padding {
    @apply pb-0;
  }

  &.no-left-margin {
    @screen md {
      @apply ml-0;
    }
    @screen xxl {
      @apply ml-0;
    }
  }
}
</style>
